// @flow

import { clientLogger } from '@flow/logging/client-logger';

function getCSSPropertyValue(variableName: string) {
  if (!variableName.startsWith('--')) {
    clientLogger.warn('Did you forget the prefix --?');
    return '';
  }

  return window.getComputedStyle(document.documentElement).getPropertyValue(variableName);
}

export default getCSSPropertyValue;
